import { useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
    primaryRowApartRequestState,
    primaryRowApartState,
} from '~/state/atoms/viewportGridAtoms';
import type { PrimaryRowApartRequest } from '~/viewportGrid';

export interface PrimaryRowPairView {
    readonly apart: boolean;
    readonly requestApart: (apart: boolean) => void;
}

export function usePrimaryRowPairView(): PrimaryRowPairView {
    const apart = useRecoilValue(primaryRowApartState);
    const setRequest = useSetRecoilState(primaryRowApartRequestState);
    const requestApart = useCallback(
        (next: boolean) => setRequest({ apart: next }),
        [setRequest]
    );
    return { apart, requestApart };
}

export interface PrimaryRowApartBinding {
    readonly primaryRowApartRequest: PrimaryRowApartRequest | undefined;
    readonly onPrimaryRowApartChanged: (apart: boolean) => void;
}

export function usePrimaryRowApartBinding(): PrimaryRowApartBinding {
    const request = useRecoilValue(primaryRowApartRequestState);
    const setApart = useSetRecoilState(primaryRowApartState);
    const onPrimaryRowApartChanged = useCallback(
        (apart: boolean) => setApart(apart),
        [setApart]
    );
    return {
        primaryRowApartRequest: request,
        onPrimaryRowApartChanged,
    };
}
